module.exports = __webpack_public_path__ + "4ac706b899d49efd74c0f0c768322fa3.svg";